import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  makeStyles
} from "@material-ui/core";

import ContactShareEditorSelect from "./ContactShareEditorSelect";

const useStyles = makeStyles(({ spacing }) => ({
  paper: {
    width: spacing(50),
    height: spacing(60)
  }
}));

const ContactShareEditor = ({
  shares: initialShares,
  contactCreatorId,
  isOpen,
  onClose,
  onSubmit
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [shares, setShares] = useState(initialShares);
  const [users, setUsers] = useState();

  const handleSharesChange = value => setShares(value);

  const handleSubmitButtonClick = () => {
    if (onSubmit) {
      onSubmit(shares);
    }
  };

  useEffect(() => {
    setShares(initialShares);
  }, [isOpen]);

  return (
    <Dialog
      classes={{
        paper: classes.paper
      }}
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {t("webapp:contact.title.share")}
      </DialogTitle>
      <ContactShareEditorSelect value={shares} contactCreatorId={contactCreatorId} onChange={handleSharesChange} />
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {t("webapp:common.title.cancel")}
        </Button>
        <Button color="primary" onClick={handleSubmitButtonClick}>
          {t("webapp:common.title.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactShareEditor;
